"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDOMPurify = void 0;
const DOMPurify_ = __importStar(require("dompurify"));
const DOMPurify = (_a = DOMPurify_ === null || DOMPurify_ === void 0 ? void 0 : DOMPurify_['default']) !== null && _a !== void 0 ? _a : DOMPurify_;
function importModule(requiredModule) {
    return (requiredModule && requiredModule.default) || requiredModule;
}
function initDOMPurifyWithJSDOM() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { JSDOM } = importModule(require('jsdom'));
    const { window } = new JSDOM('<!DOCTYPE html>');
    return DOMPurify(window);
}
/**
 * Resolves the DOMPurify instance based on the environment. DOMPurify is used to sanitize HTML strings
 * and relies on DOM APIs that are not available in Node.js. For server-side code, we can use JSDOM to
 * create a window object that provides the necessary APIs.
 *
 * If the environment is client-side, it returns the global DOMPurify instance.
 * If the environment is server-side, it returns a new DOMPurify instance created with a JSDOM window.
 *
 * @returns DOMPurify instance
 */
function resolveDOMPurify() {
    const isClientSide = typeof window !== 'undefined';
    return isClientSide ? DOMPurify : initDOMPurifyWithJSDOM();
}
exports.resolveDOMPurify = resolveDOMPurify;
//# sourceMappingURL=dompurify.js.map